var _path, _g, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_432_3883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 14,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333313 11.0801H13.5332V17.2251H0.333313V11.0801Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_432_3883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93409 12.3301C3.38325 12.3301 1.58325 12.9401 1.58325 14.1442C1.58325 15.3592 3.38325 15.9751 6.93409 15.9751C10.4841 15.9751 12.2833 15.3651 12.2833 14.1609C12.2833 12.9459 10.4841 12.3301 6.93409 12.3301ZM6.93409 17.2251C5.30159 17.2251 0.333252 17.2251 0.333252 14.1442C0.333252 11.3976 4.10075 11.0801 6.93409 11.0801C8.56659 11.0801 13.5333 11.0801 13.5333 14.1609C13.5333 16.9076 9.76659 17.2251 6.93409 17.2251Z",
    fill: "#5D6373"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_432_3883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50818 0.666016H11.3582V9.51485H2.50818V0.666016Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_432_3883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93404 1.85602C5.14987 1.85602 3.6982 3.30685 3.6982 5.09102C3.69237 6.86935 5.1332 8.31935 6.90987 8.32602L6.93404 8.92101V8.32602C8.71737 8.32602 10.1682 6.87435 10.1682 5.09102C10.1682 3.30685 8.71737 1.85602 6.93404 1.85602ZM6.93404 9.51518H6.90737C4.47237 9.50768 2.49987 7.52185 2.50821 5.08852C2.50821 2.65102 4.4932 0.666016 6.93404 0.666016C9.37404 0.666016 11.3582 2.65102 11.3582 5.09102C11.3582 7.53102 9.37404 9.51518 6.93404 9.51518Z",
    fill: "#5D6373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.0f92601011c45210216fd151857a486f.svg";
export { ForwardRef as ReactComponent };